import { ReactComponent as LoadingSvg } from '../assets/svg/loading-half-status.svg';

const PopUpNotification = ({
  open,
  title,
  children,
  close,
  disabled = false,
  loading = false,
}) => {
  return (
    <dialog
      open={open}
      className='fixed top-[50%] translate-y-[-50%] border-2 border-black px-4 py-3 rounded-xl bg-white w-5/6 z-50 max-w-lg'
    >
      <h1 className='font-bold mb-4'>{title}</h1>
      <div className='whitespace-pre-line'>{children}</div>
      <footer className='mt-4'>
        <button
          className={`border rounded-xl w-full py-1 bg-black text-white flex justify-center ${
            disabled && 'opacity-40'
          }`}
          onClick={close}
          disabled={disabled}
        >
          {loading ? <LoadingSvg className='size-4 animate-spin' /> : 'OK'}
        </button>
      </footer>
    </dialog>
  );
};

export default PopUpNotification;
